<template>
  <router-view :user_profile="user_profile"> </router-view>
</template>
<script>
export default {
  props: ["user_profile"]
};
</script>
